import * as service from "../common/service";
import { getCurrentApiBaseUrl } from "../common/constants";

const customFieldApi = `${getCurrentApiBaseUrl()}/user/custom-field`;

const customFieldService = {
  getCustomFieldList: (payload) => {
    return service.get(`${customFieldApi}?fieldArea=${payload}`, {});
  },
};

export default customFieldService;
